import http from "@http"
//角色列表  不分页
export function getRoleAll(data) {
    return http({
        url: '/lskj-admin/api/admin/role/all',
        method: "post",
        data
    })
}
//角色列表  分页
export function getRoleList(data) {
    return http({
        url: '/lskj-admin/api/admin/role/list',
        method: "post",
        data
    })
}

//查询单条角色信息
export function roleById(data) {
    return http({
        url: `/lskj-admin/api/admin/role/byId?id=${data.id}`,
        method: "get",
    })
}

//添加部门
export function roleAdd(data) {
    return http({
        url: '/lskj-admin/api/admin/role/add',
        method: "post",
        data
    })
}

//修改部门信息
export function updeteRole(data) {
    return http({
        url: `/lskj-admin/api/admin/role`,
        method: "put",
        data
    })
}
//删除部门信息
export function deleteRole(data) {
    return http({
        url: `/lskj-admin/api/admin/role?ids=${data.ids}`,
        method: "delete",
        data
    })
}